import React from 'react'

export const NoMatch = () => (
    <div>
        <h2> No Match </h2>
        <p> Go to https://www.sense4me.com  </p>

    </div>

)